import ClientsGridRowWrapper from '../ClientsGridRowWrapper';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ClientsGridHeader: FunctionComponent<Props> = ({ children, ref, testId = TEST_ID }) => (
    <ClientsGridRowWrapper ref={ref} testId={testId}>
        {children}
    </ClientsGridRowWrapper>
);

export default ClientsGridHeader;
